import React, { useState } from "react";
import { slimBoxes } from "./data/slimBoxData";
import "../../App.css";
import { Helmet } from "react-helmet";
import banner from "../../assets/slim-box-banner.webp";

const SlimBox = () => {
  const [selectedSlimBox, setSelectedSlimBox] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [activeTab, setActiveTab] = useState("desc");
const [previewImage, setPreviewImage] = useState(null);
  // ✅ YouTube Embed Fix
  const getEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("watch?v=")) {
      const id = url.split("v=")[1]?.split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    return url;
  };

  // ✅ Watch URL Fix
  const getWatchUrl = (url) => {
    if (!url) return "";

    if (url.includes("shorts")) {
      const id = url.split("/shorts/")[1]?.split("?")[0];
      return `https://www.youtube.com/watch?v=${id}`;
    }

    if (url.includes("embed")) {
      const id = url.split("/embed/")[1];
      return `https://www.youtube.com/watch?v=${id}`;
    }

    return url;
  };

  const filteredSlimBox = slimBoxes.filter(
    (item) => item.category === "slim-box"
  );

  if (!filteredSlimBox.length)
    return <p style={{ textAlign: "center" }}>No products found.</p>;

  return (
    <div className="product-container">

      <Helmet>
        <link
    rel="canonical"
    href="https://slimlinehardwarefittings.com/slim-box"
  />
        <title>Slim Box Drawer System | Modern Kitchen Drawers</title>
        <meta
          name="description"
          content="Stylish slim box drawer systems with soft close technology for modular kitchens."
        />
      </Helmet>

      {/* ===== BANNER ===== */}
      <div className="hinge-banners">
        <img src={banner} rel="preload" alt="Slim Box Banner"  loading="lazy"/>
        <h2 className="banner-text">Products</h2>
      </div>

      <h2 style={{ textAlign: "center", fontSize: "2rem", padding: "10px" }}>
        MODULAR STORAGE
      </h2>

      {!selectedSlimBox ? (

        /* ===== CARD VIEW ===== */
        <div className="product-grid">
          {filteredSlimBox.map((item) => (
            <div
              className="product-card"
              key={item.code}
              onClick={() => {
                setSelectedSlimBox(item);
                setMainImage(item.mainImage);
                setActiveFAQ(null);
                setActiveTab("desc");
              }}
            >
             <img
  src={item.mainImage}
  alt={item.name}
  loading="lazy"
  onClick={(e) => {
    e.stopPropagation();
    setPreviewImage(item.mainImage);
  }}
  style={{ cursor: "zoom-in" }}
/>
              <h4>{item.name}</h4>
            </div>
          ))}
        </div>

      ) : (

        <>
          {/* ===== BACK BUTTON ===== */}
          <button
            className="back-btn"
            onClick={() => {
              setSelectedSlimBox(null);
              setMainImage("");
              setActiveFAQ(null);
            }}
          >
            ← Back
          </button>

          <div className="hinge-details">

            {/* ===== LEFT ===== */}
            <div className="left-box">

              <div className="hinge-image">
                <img
  src={mainImage}
  alt={selectedSlimBox?.name}
  className="zoomable-image"
  onClick={() => setPreviewImage(mainImage)}
/>
              </div>

              <div className="hinge-thumbnails">
                {selectedSlimBox.thumbnails.map((img, i) => (
                 <img
  key={i}
  src={img}
  alt=""
  loading="lazy"
  onClick={() => setMainImage(img)}
  onDoubleClick={() => setPreviewImage(img)}
/>
                ))}
              </div>

              {/* VIDEO */}
              {selectedSlimBox.video && (
                <div className="product-video">
                  <iframe
                    width="100%"
                    height="300"
                    src={getEmbedUrl(selectedSlimBox.video)}
                    title="Product Video"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              )}

            </div>

            {/* ===== RIGHT ===== */}
            <div className="hinge-info">

              <h2>{selectedSlimBox.name}</h2>

              {/* PRICE */}
              <div className="price-box">
                <span className="price">{selectedSlimBox.price}</span>
                <span className="old-price">{selectedSlimBox.oldPrice}</span>
              </div>

              {/* META */}
              <div className="product-meta">
                <p><strong>SKU:</strong> {selectedSlimBox.sku}</p>
                <p><strong>Status:</strong> {selectedSlimBox.stock}</p>
              </div>

              {/* BUTTONS */}
              <div className="btns">

                {selectedSlimBox.catalogue && (
                  <a href={selectedSlimBox.catalogue} download>
                    📥 Download Catalogue
                  </a>
                )}

                {selectedSlimBox.inquiry && (
                  <a href={selectedSlimBox.inquiry} target="_blank" rel="noreferrer">
                    💬 Inquiry
                  </a>
                )}

                {selectedSlimBox.video && (
                  <a href={getWatchUrl(selectedSlimBox.video)} target="_blank" rel="noreferrer">
                    ▶ Watch Video
                  </a>
                )}

              </div>

              {/* TABS */}
              <div className="tabs">
                <button onClick={() => setActiveTab("desc")}>
                  Description
                </button>
                <button onClick={() => setActiveTab("info")}>
                  Additional Info
                </button>
              </div>

              {/* DESCRIPTION */}
              {activeTab === "desc" && (
                <>
                  <p>{selectedSlimBox.short}</p>
                  <ul>
                    {selectedSlimBox.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </>
              )}

              {/* ✅ FIXED ADDITIONAL INFO (PULLOUT STYLE TABLE) */}
              {activeTab === "info" && (
                <div className="info-table">
                  {selectedSlimBox.specifications?.length ? (
                    <table>
                      <tbody>
                        {selectedSlimBox.specifications.map((s, i) => (
                          <tr key={i}>
                            <td><strong>{s.label}</strong></td>
                            <td>{s.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No additional info</p>
                  )}
                </div>
              )}

            </div>
          </div>

          {/* ===== SPEC TABLE ===== */}
          {selectedSlimBox.specTable && (
            <div className="spec-section">
              <h2>Specifications</h2>

              <table className="spec-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Code</th>
                    <th>Size</th>
                    <th>Finish</th>
                  </tr>
                </thead>

                <tbody>
                  {selectedSlimBox.specTable.map((item, i) => (
                    <tr key={i}>
                      <td>{item.item}</td>
                      <td>{item.code}</td>
                      <td>{item.size}</td>
                      <td>{item.finish}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* ===== FAQ ===== */}
          {selectedSlimBox.faq && (
            <div className="faq-section">
              <h2>Frequently Asked Questions</h2>

              {selectedSlimBox.faq.map((item, index) => (
                <div key={index} className="faq-box">

                  <div
                    className={`faq-question ${activeFAQ === index ? "active" : ""}`}
                    onClick={() =>
                      setActiveFAQ(activeFAQ === index ? null : index)
                    }
                  >
                    <h4>{item.question}</h4>
                    <span className="faq-icon">
                      {activeFAQ === index ? "−" : "+"}
                    </span>
                  </div>

                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}

                </div>
              ))}

            </div>
          )}
{previewImage && (
  <div
    className="image-preview-modal"
    onClick={() => setPreviewImage(null)}
  >
    <span
      className="image-preview-close"
      onClick={() => setPreviewImage(null)}
    >
      ✕
    </span>

    <img
      src={previewImage}
      alt="Preview"
      className="image-preview-full"
      onClick={(e) => e.stopPropagation()}
    />
  </div>
)}
        </>
      )}
    </div>
  );
};

export default SlimBox;